export function separateByUppercase(string) {
  return string.split(/(?=[A-Z])/).join(' ');
}

export function separateByUppercaseAndJoinedWithHorLine(string) {
  return string
    .split(/(?=[A-Z])/)
    .join('_')
    .toUpperCase();
}

export function separateByUnderscore(string) {
  return string.replaceAll('_', ' ');
}

export function joinArrayWithComma(arr) {
  return arr.join(', ');
}

export const removeControlCharacters = (anyString) => {
  if (!anyString || typeof anyString !== 'string') {
    return anyString;
  }

  const sanitizedString = [];
  anyString.split(' ').forEach((singleWord) => {
    const reformedWord = singleWord
      .split('')
      .filter((singleChar) => {
        const charValue = singleChar.codePointAt(0);
        if ((charValue >= 9216 && charValue <= 9247) || charValue === 9249) {
          return null;
        }
        return singleChar;
      })
      .join('');
    sanitizedString.push(reformedWord);
  });

  return sanitizedString.join(' ');
};
